/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as ChatThreadsRouteImport } from './routes/_chat.threads'
import { Route as ChatSnoozedRouteImport } from './routes/_chat.snoozed'
import { Route as ChatSettingsRouteImport } from './routes/_chat.settings'
import { Route as ChatPullRequestsRouteImport } from './routes/_chat.pull-requests'
import { Route as ChatPluginsRouteImport } from './routes/_chat.plugins'
import { Route as ChatThreadIdRouteImport } from './routes/_chat.$threadId'
import { Route as ChatWorkspaceIndexRouteImport } from './routes/_chat.workspace.index'
import { Route as ChatWorkspaceWorkspaceIdRouteImport } from './routes/_chat.workspace.$workspaceId'
import { Route as ChatProjectsProjectIdRouteImport } from './routes/_chat.projects.$projectId'
import { Route as ChatProjectsProjectIdIndexRouteImport } from './routes/_chat.projects.$projectId.index'
import { Route as ChatProjectsProjectIdThreadsRouteImport } from './routes/_chat.projects.$projectId.threads'
import { Route as ChatProjectsProjectIdSnoozedRouteImport } from './routes/_chat.projects.$projectId.snoozed'
import { Route as ChatProjectsProjectIdPullRequestsRouteImport } from './routes/_chat.projects.$projectId.pull-requests'
import { Route as ChatProjectsProjectIdEnvironmentsRouteImport } from './routes/_chat.projects.$projectId.environments'
import { Route as ChatProjectsProjectIdAgentsRouteImport } from './routes/_chat.projects.$projectId.agents'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const ChatThreadsRoute = ChatThreadsRouteImport.update({
  id: '/threads',
  path: '/threads',
  getParentRoute: () => ChatRoute,
} as any)
const ChatSnoozedRoute = ChatSnoozedRouteImport.update({
  id: '/snoozed',
  path: '/snoozed',
  getParentRoute: () => ChatRoute,
} as any)
const ChatSettingsRoute = ChatSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ChatRoute,
} as any)
const ChatPullRequestsRoute = ChatPullRequestsRouteImport.update({
  id: '/pull-requests',
  path: '/pull-requests',
  getParentRoute: () => ChatRoute,
} as any)
const ChatPluginsRoute = ChatPluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => ChatRoute,
} as any)
const ChatThreadIdRoute = ChatThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatWorkspaceIndexRoute = ChatWorkspaceIndexRouteImport.update({
  id: '/workspace/',
  path: '/workspace/',
  getParentRoute: () => ChatRoute,
} as any)
const ChatWorkspaceWorkspaceIdRoute =
  ChatWorkspaceWorkspaceIdRouteImport.update({
    id: '/workspace/$workspaceId',
    path: '/workspace/$workspaceId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatProjectsProjectIdRoute = ChatProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatProjectsProjectIdIndexRoute =
  ChatProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ChatProjectsProjectIdRoute,
  } as any)
const ChatProjectsProjectIdThreadsRoute =
  ChatProjectsProjectIdThreadsRouteImport.update({
    id: '/threads',
    path: '/threads',
    getParentRoute: () => ChatProjectsProjectIdRoute,
  } as any)
const ChatProjectsProjectIdSnoozedRoute =
  ChatProjectsProjectIdSnoozedRouteImport.update({
    id: '/snoozed',
    path: '/snoozed',
    getParentRoute: () => ChatProjectsProjectIdRoute,
  } as any)
const ChatProjectsProjectIdPullRequestsRoute =
  ChatProjectsProjectIdPullRequestsRouteImport.update({
    id: '/pull-requests',
    path: '/pull-requests',
    getParentRoute: () => ChatProjectsProjectIdRoute,
  } as any)
const ChatProjectsProjectIdEnvironmentsRoute =
  ChatProjectsProjectIdEnvironmentsRouteImport.update({
    id: '/environments',
    path: '/environments',
    getParentRoute: () => ChatProjectsProjectIdRoute,
  } as any)
const ChatProjectsProjectIdAgentsRoute =
  ChatProjectsProjectIdAgentsRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => ChatProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/login': typeof LoginRoute
  '/$threadId': typeof ChatThreadIdRoute
  '/plugins': typeof ChatPluginsRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/settings': typeof ChatSettingsRoute
  '/snoozed': typeof ChatSnoozedRoute
  '/threads': typeof ChatThreadsRoute
  '/projects/$projectId': typeof ChatProjectsProjectIdRouteWithChildren
  '/workspace/$workspaceId': typeof ChatWorkspaceWorkspaceIdRoute
  '/workspace/': typeof ChatWorkspaceIndexRoute
  '/projects/$projectId/agents': typeof ChatProjectsProjectIdAgentsRoute
  '/projects/$projectId/environments': typeof ChatProjectsProjectIdEnvironmentsRoute
  '/projects/$projectId/pull-requests': typeof ChatProjectsProjectIdPullRequestsRoute
  '/projects/$projectId/snoozed': typeof ChatProjectsProjectIdSnoozedRoute
  '/projects/$projectId/threads': typeof ChatProjectsProjectIdThreadsRoute
  '/projects/$projectId/': typeof ChatProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/$threadId': typeof ChatThreadIdRoute
  '/plugins': typeof ChatPluginsRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/settings': typeof ChatSettingsRoute
  '/snoozed': typeof ChatSnoozedRoute
  '/threads': typeof ChatThreadsRoute
  '/': typeof ChatIndexRoute
  '/workspace/$workspaceId': typeof ChatWorkspaceWorkspaceIdRoute
  '/workspace': typeof ChatWorkspaceIndexRoute
  '/projects/$projectId/agents': typeof ChatProjectsProjectIdAgentsRoute
  '/projects/$projectId/environments': typeof ChatProjectsProjectIdEnvironmentsRoute
  '/projects/$projectId/pull-requests': typeof ChatProjectsProjectIdPullRequestsRoute
  '/projects/$projectId/snoozed': typeof ChatProjectsProjectIdSnoozedRoute
  '/projects/$projectId/threads': typeof ChatProjectsProjectIdThreadsRoute
  '/projects/$projectId': typeof ChatProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/login': typeof LoginRoute
  '/_chat/$threadId': typeof ChatThreadIdRoute
  '/_chat/plugins': typeof ChatPluginsRoute
  '/_chat/pull-requests': typeof ChatPullRequestsRoute
  '/_chat/settings': typeof ChatSettingsRoute
  '/_chat/snoozed': typeof ChatSnoozedRoute
  '/_chat/threads': typeof ChatThreadsRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/projects/$projectId': typeof ChatProjectsProjectIdRouteWithChildren
  '/_chat/workspace/$workspaceId': typeof ChatWorkspaceWorkspaceIdRoute
  '/_chat/workspace/': typeof ChatWorkspaceIndexRoute
  '/_chat/projects/$projectId/agents': typeof ChatProjectsProjectIdAgentsRoute
  '/_chat/projects/$projectId/environments': typeof ChatProjectsProjectIdEnvironmentsRoute
  '/_chat/projects/$projectId/pull-requests': typeof ChatProjectsProjectIdPullRequestsRoute
  '/_chat/projects/$projectId/snoozed': typeof ChatProjectsProjectIdSnoozedRoute
  '/_chat/projects/$projectId/threads': typeof ChatProjectsProjectIdThreadsRoute
  '/_chat/projects/$projectId/': typeof ChatProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/$threadId'
    | '/plugins'
    | '/pull-requests'
    | '/settings'
    | '/snoozed'
    | '/threads'
    | '/projects/$projectId'
    | '/workspace/$workspaceId'
    | '/workspace/'
    | '/projects/$projectId/agents'
    | '/projects/$projectId/environments'
    | '/projects/$projectId/pull-requests'
    | '/projects/$projectId/snoozed'
    | '/projects/$projectId/threads'
    | '/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/$threadId'
    | '/plugins'
    | '/pull-requests'
    | '/settings'
    | '/snoozed'
    | '/threads'
    | '/'
    | '/workspace/$workspaceId'
    | '/workspace'
    | '/projects/$projectId/agents'
    | '/projects/$projectId/environments'
    | '/projects/$projectId/pull-requests'
    | '/projects/$projectId/snoozed'
    | '/projects/$projectId/threads'
    | '/projects/$projectId'
  id:
    | '__root__'
    | '/_chat'
    | '/login'
    | '/_chat/$threadId'
    | '/_chat/plugins'
    | '/_chat/pull-requests'
    | '/_chat/settings'
    | '/_chat/snoozed'
    | '/_chat/threads'
    | '/_chat/'
    | '/_chat/projects/$projectId'
    | '/_chat/workspace/$workspaceId'
    | '/_chat/workspace/'
    | '/_chat/projects/$projectId/agents'
    | '/_chat/projects/$projectId/environments'
    | '/_chat/projects/$projectId/pull-requests'
    | '/_chat/projects/$projectId/snoozed'
    | '/_chat/projects/$projectId/threads'
    | '/_chat/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/threads': {
      id: '/_chat/threads'
      path: '/threads'
      fullPath: '/threads'
      preLoaderRoute: typeof ChatThreadsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/snoozed': {
      id: '/_chat/snoozed'
      path: '/snoozed'
      fullPath: '/snoozed'
      preLoaderRoute: typeof ChatSnoozedRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/settings': {
      id: '/_chat/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ChatSettingsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/pull-requests': {
      id: '/_chat/pull-requests'
      path: '/pull-requests'
      fullPath: '/pull-requests'
      preLoaderRoute: typeof ChatPullRequestsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/plugins': {
      id: '/_chat/plugins'
      path: '/plugins'
      fullPath: '/plugins'
      preLoaderRoute: typeof ChatPluginsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$threadId': {
      id: '/_chat/$threadId'
      path: '/$threadId'
      fullPath: '/$threadId'
      preLoaderRoute: typeof ChatThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/workspace/': {
      id: '/_chat/workspace/'
      path: '/workspace'
      fullPath: '/workspace/'
      preLoaderRoute: typeof ChatWorkspaceIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/workspace/$workspaceId': {
      id: '/_chat/workspace/$workspaceId'
      path: '/workspace/$workspaceId'
      fullPath: '/workspace/$workspaceId'
      preLoaderRoute: typeof ChatWorkspaceWorkspaceIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/projects/$projectId': {
      id: '/_chat/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ChatProjectsProjectIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/projects/$projectId/': {
      id: '/_chat/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ChatProjectsProjectIdIndexRouteImport
      parentRoute: typeof ChatProjectsProjectIdRoute
    }
    '/_chat/projects/$projectId/threads': {
      id: '/_chat/projects/$projectId/threads'
      path: '/threads'
      fullPath: '/projects/$projectId/threads'
      preLoaderRoute: typeof ChatProjectsProjectIdThreadsRouteImport
      parentRoute: typeof ChatProjectsProjectIdRoute
    }
    '/_chat/projects/$projectId/snoozed': {
      id: '/_chat/projects/$projectId/snoozed'
      path: '/snoozed'
      fullPath: '/projects/$projectId/snoozed'
      preLoaderRoute: typeof ChatProjectsProjectIdSnoozedRouteImport
      parentRoute: typeof ChatProjectsProjectIdRoute
    }
    '/_chat/projects/$projectId/pull-requests': {
      id: '/_chat/projects/$projectId/pull-requests'
      path: '/pull-requests'
      fullPath: '/projects/$projectId/pull-requests'
      preLoaderRoute: typeof ChatProjectsProjectIdPullRequestsRouteImport
      parentRoute: typeof ChatProjectsProjectIdRoute
    }
    '/_chat/projects/$projectId/environments': {
      id: '/_chat/projects/$projectId/environments'
      path: '/environments'
      fullPath: '/projects/$projectId/environments'
      preLoaderRoute: typeof ChatProjectsProjectIdEnvironmentsRouteImport
      parentRoute: typeof ChatProjectsProjectIdRoute
    }
    '/_chat/projects/$projectId/agents': {
      id: '/_chat/projects/$projectId/agents'
      path: '/agents'
      fullPath: '/projects/$projectId/agents'
      preLoaderRoute: typeof ChatProjectsProjectIdAgentsRouteImport
      parentRoute: typeof ChatProjectsProjectIdRoute
    }
  }
}

interface ChatProjectsProjectIdRouteChildren {
  ChatProjectsProjectIdAgentsRoute: typeof ChatProjectsProjectIdAgentsRoute
  ChatProjectsProjectIdEnvironmentsRoute: typeof ChatProjectsProjectIdEnvironmentsRoute
  ChatProjectsProjectIdPullRequestsRoute: typeof ChatProjectsProjectIdPullRequestsRoute
  ChatProjectsProjectIdSnoozedRoute: typeof ChatProjectsProjectIdSnoozedRoute
  ChatProjectsProjectIdThreadsRoute: typeof ChatProjectsProjectIdThreadsRoute
  ChatProjectsProjectIdIndexRoute: typeof ChatProjectsProjectIdIndexRoute
}

const ChatProjectsProjectIdRouteChildren: ChatProjectsProjectIdRouteChildren = {
  ChatProjectsProjectIdAgentsRoute: ChatProjectsProjectIdAgentsRoute,
  ChatProjectsProjectIdEnvironmentsRoute:
    ChatProjectsProjectIdEnvironmentsRoute,
  ChatProjectsProjectIdPullRequestsRoute:
    ChatProjectsProjectIdPullRequestsRoute,
  ChatProjectsProjectIdSnoozedRoute: ChatProjectsProjectIdSnoozedRoute,
  ChatProjectsProjectIdThreadsRoute: ChatProjectsProjectIdThreadsRoute,
  ChatProjectsProjectIdIndexRoute: ChatProjectsProjectIdIndexRoute,
}

const ChatProjectsProjectIdRouteWithChildren =
  ChatProjectsProjectIdRoute._addFileChildren(
    ChatProjectsProjectIdRouteChildren,
  )

interface ChatRouteChildren {
  ChatThreadIdRoute: typeof ChatThreadIdRoute
  ChatPluginsRoute: typeof ChatPluginsRoute
  ChatPullRequestsRoute: typeof ChatPullRequestsRoute
  ChatSettingsRoute: typeof ChatSettingsRoute
  ChatSnoozedRoute: typeof ChatSnoozedRoute
  ChatThreadsRoute: typeof ChatThreadsRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ChatProjectsProjectIdRoute: typeof ChatProjectsProjectIdRouteWithChildren
  ChatWorkspaceWorkspaceIdRoute: typeof ChatWorkspaceWorkspaceIdRoute
  ChatWorkspaceIndexRoute: typeof ChatWorkspaceIndexRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatThreadIdRoute: ChatThreadIdRoute,
  ChatPluginsRoute: ChatPluginsRoute,
  ChatPullRequestsRoute: ChatPullRequestsRoute,
  ChatSettingsRoute: ChatSettingsRoute,
  ChatSnoozedRoute: ChatSnoozedRoute,
  ChatThreadsRoute: ChatThreadsRoute,
  ChatIndexRoute: ChatIndexRoute,
  ChatProjectsProjectIdRoute: ChatProjectsProjectIdRouteWithChildren,
  ChatWorkspaceWorkspaceIdRoute: ChatWorkspaceWorkspaceIdRoute,
  ChatWorkspaceIndexRoute: ChatWorkspaceIndexRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
